export const _makeLong = a => a
export const sep = '/'
export const delimiter = ':'

export { default as basename } from './lib/basename.js'
export { default as dirname } from './lib/dirname.js'
export { default as extname } from './lib/extname.js'
export { default as format } from './lib/format.js'
export { default as isAbsolute } from './lib/isAbsolute.js'
export { default as join } from './lib/join.js'
export { default as normalize } from './lib/normalize.js'
export { default as parse } from './lib/parse.js'
export { default as relative } from './lib/relative.js'
export { default as resolve } from './lib/resolve.js'

export * as default from './index.js'
export * as win32 from './index.js'
export * as posix from './index.js'
